module.exports = __webpack_public_path__ + "img/assist-symbol.f34229ea.svg";